import { useMemo, useCallback, useRef, useEffect } from 'react';
import {
  getCurrentStepId, WIZARD_EVENTS,
} from '@bingads-webui-react/wizard';

export const LOG_STATUS = {
  LOAD_START: 'load_start',
  LOAD_SUCCESS: 'load_success',
  SAVE_START: 'save_start',
  SAVE_SUCCESS: 'save_success',
  SAVE_FAIL: 'save_fail',
  CANCEL: 'cancel',
};

export const useWizardLog = ({
  activity, wizardState, isSearch, flow,
}) => {
  const stepTime = useRef({
    loadStart: 0,
    loadEnd: 0,
    saveStart: 0,
    saveEnd: 0,
  });

  const logContent = useMemo(() => ({
    flow: flow || `${isSearch ? 'search' : 'audience'}-shopping/new`,
    step: getCurrentStepId(wizardState),
    stepDuration: 0,
    requestSpend: 0,
    msg: '',
    status: '',
    guid: activity.id,
  }), [flow, isSearch, wizardState, activity.id]);

  const traceLog = useCallback((logPayload) => {
    activity.trace(JSON.stringify(logPayload));
  }, [activity]);

  const onStepLoadedLog = useCallback(({ status, msg = '' }) => {
    const nowTime = Date.now();
    const logs = { status };
    if (msg) {
      logs.msg = msg;
    }
    if (status === LOG_STATUS.LOAD_START) {
      stepTime.current.loadStart = nowTime;
    } else if (status === LOG_STATUS.LOAD_SUCCESS) {
      stepTime.current.loadEnd = nowTime;
      logs.requestSpend = nowTime - stepTime.current.loadStart;
    }
    traceLog({
      ...logContent,
      ...logs,
      status,
    });
  }, [logContent, stepTime, traceLog]);

  const onStepSavedLog = useCallback(({ status, msg = '' }) => {
    const nowTime = Date.now();
    const logs = { status };
    if (msg) {
      logs.msg = msg;
    }
    if (status === LOG_STATUS.SAVE_START) {
      stepTime.current.saveStart = nowTime;
    } else if (status === LOG_STATUS.SAVE_SUCCESS || status === LOG_STATUS.SAVE_FAIL) {
      logs.requestSpend = nowTime - stepTime.current.saveStart;
      logs.stepDuration = nowTime - stepTime.current.loadEnd;
    }
    traceLog({
      ...logContent,
      ...logs,
    });
  }, [logContent, stepTime, traceLog]);

  useEffect(() => (() => {
    if (wizardState.event.type === WIZARD_EVENTS.CANCEL) {
      traceLog({
        ...logContent,
        status: LOG_STATUS.CANCEL,
        stepDuration: Date.now() - stepTime.current.loadEnd,
      });
    }
  }), [wizardState, logContent, traceLog]);

  return {
    onStepLoadedLog,
    onStepSavedLog,
  };
};
